export const buildersCoreConfig = {
  baseUrl: '/builders',
};
